// SPDX-FileCopyrightText: 2024 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { Colors } from '@tls/treact-ui';
import React from 'react';
import styled from 'styled-components';
import LabelColorRect from './LabelColorRect';
import { ModelClassMessage } from '@tls/sw91-communication/types/com.base';

interface Props {
  usedLabels: number[];
  isLoading?: boolean;
  modelClasses: ModelClassMessage[];
}

export default function UsedLabels({ usedLabels, isLoading, modelClasses }: Readonly<Props>) {
  return (
    <Root>
      <Grid>
        {modelClasses.map((modelClass, index) => {
          const isUsedLabel = usedLabels.includes(index + 1);
          return (
            <LabelItem key={modelClass.classIndex}>
              <LabelColorRect
                size={'16px'}
                isUsedLabel={isUsedLabel}
                labelColor={modelClass.labelColor}
                isLoading={isLoading}
              />
              <LabelName $color={isUsedLabel ? undefined : Colors.trgrey2.hex}>{modelClass.className}</LabelName>
            </LabelItem>
          );
        })}
      </Grid>
    </Root>
  );
}

const Root = styled.div`
  width: 100%;
`;
const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  width: 100%;
`;

const LabelItem = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
  width: 100%;
`;
const LabelName = styled.div<{ $color }>`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex: 1;
  color: ${props => props.$color};
`;
